import {GuidIdAndLabel, BrandAndMarketListItem, GuidIdCodeAndLabel} from '../../../../integrated-client/models';
import { DEFAULT_LIMIT_PAGINATION, DEFAULT_OFFSET } from '../../../../utils/Constants';

export interface IFiltersData {
  brandAndMarket?: BrandAndMarketListItem;
  carrier?: GuidIdCodeAndLabel;
  description?: string | null;
  showDeleted?: boolean;
  showDisabled?: boolean;
  offset?: number | null;
  limit?: number | null;
}

export class FiltersData implements IFiltersData {
  brandAndMarket?: BrandAndMarketListItem;
  carrier?: GuidIdCodeAndLabel;
  description?: string | null;
  showDeleted?: boolean;
  showDisabled?: boolean;
  offset?: number | null;
  limit?: number | null;

  constructor() {
    this.offset = DEFAULT_OFFSET
    this.limit = DEFAULT_LIMIT_PAGINATION
  }
}
